import React, { Component } from "react";
import { Icon } from '@fluentui/react/lib/Icon';
import { getFileTypeIconProps } from '@uifabric/file-type-icons';

interface IconBuilderProps {
    extension: string
    size: number
}

class IconBuilder extends Component<IconBuilderProps> {

    render() {
        //@ts-ignore
        return (<Icon {...getFileTypeIconProps({ extension: this.props.extension, size: this.props.size })}></Icon>)
    }
}

export default IconBuilder